// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S4864","option":"styles_option__aeo2R","active":"styles_active__13Eiu"};